// 存储登录信息的
export const KEY = '__snipe4help__';
// 加载的战术json
export const KEY_TACTIC = '__snipe4tactic__';

export const ERR_OK = 0;

export const BASE_URL =  window.setting.baseUrl;
// export const BASE_URL =  process.env.NODE_ENV === 'production' ? '/' : 'http://192.168.3.210/snipe4/server/';

export const STATUS = {
    outline: 0,
    online: 1,
    waiting: 2
};
